import react, { useState, useEffect } from 'react'

import Axios from 'axios';
import { CitationTable } from '../CitationTable/CitationTable';
import { CitationTableList } from '../CitationTableList/CitationTableList';
import { Cosmograph, CosmographProvider, CosmographHistogram, CosmographSearch } from '@cosmograph/react'
import { getCitationCounts } from './queries';
import { PCAChart } from '../PCAChart/PCAChart';
import {Spinner} from '../Spinner/Spinner'

import * as CitationTableWrapperTypes from './CitationTableWrapperTypes';

import './CitationTableWrapper.css';


interface MyComponentProps {
  resourceid?: string;
  sourceResourceid?: string;
  startLevel?: number;
  sourceLevel?: number;
  yValueType?: string;
  xValueType?: string;
  autoQuery?: boolean;
  showQueryMenu?: boolean;
}


const sigmoid = (x) => 1 / (1 + Math.exp(-x));

const colors = ['#88C6FF', '#FF99D2', '#2748A4'];

export const CitationTableWrapper: React.FC<MyComponentProps> = (props) => {
  const startResourceUrlParam = "" //Qs.parse(props.location.search, { ignoreQueryPrefix: true }).start
  const startLevelUrlParam = "" //Qs.parse(props.location.search, { ignoreQueryPrefix: true }).startLevel
  const sourceResourceUrlParam = "" //Qs.parse(props.location.search, { ignoreQueryPrefix: true }).source
  const sourceLevelUrlParam = "" //Qs.parse(props.location.search, { ignoreQueryPrefix: true }).sourceLevel
  const [start, setStart] = useState(props.resourceid || "http://scta.info/resource/lombardsententia")
  const [startCurrentLevel, setStartCurrentLevel] = useState()
  const [divLevel, setDivLevel] = useState<number>(props.startLevel || 2)
  const [divLevelInput, setDivLevelInput] = useState<string>(String(props.startLevel || 2));
  const [source, setSource] = useState(props.sourceResourceid || "http://scta.info/resource/augustinedetrinitate")
  // const [workGroupStart, setWorkGroupStart] = useState("http://scta.info/resource/scta")
  // const [workGroupSource, setWorkGroupSource] = useState("http://scta.info/resource/scta")
  const [sourceLevel, setSourceLevel] = useState<number>(props.sourceLevel || 2)
  const [sourceLevelInput, setSourceLevelInput] = useState<string>(String(props.sourceLevel || 2));
  const [dataResult, setDataResult] = useState<any[]>([])
  const [isFetching, setIsFetching] = useState(false)
  const [xValues, setXValues] = useState<CitationTableWrapperTypes.XValuesHash>({})
  const [xValueIds, setXValueIds] = useState<string[]>([])
  const [yValues, setYValues] = useState<CitationTableWrapperTypes.YValuesHash>({})
  const [yValueIds, setYValueIds] = useState<string[]>([])
  const [countHash, setCountHash] = useState<{[key: string]: {[key: string]: number}}>({})
  const [countMatrix, setCountMatrix] = useState({})
  const [yValueType, setYValueType] = useState(props.yValueType || "TopLevelExpression")
  const [xValueType, setXValueType] = useState(props.xValueType || "TopLevelExpression")
  const [targetExpressionTypes, setTargetExpressionTypes] = useState([])
  const [constrainedView, setConstrainedView] = useState(false)
  const [nodes, setNodes] = useState<CitationTableWrapperTypes.Node[]>([])
  const [links, setLinks] = useState<CitationTableWrapperTypes.Link[]>([])
  const [showPCA, setShowPCA] = useState(false)
  const [showGraph, setShowGraph] = useState(false)
  const [showCitations, setShowCitations] = useState(false)
  const [expressionTypeRollup, setExpressionTypeRollup] = useState(false)

  
  useEffect(() => {
    if (props.resourceid) { 
      setStart(props.resourceid)
    }
  }, [props.resourceid])

  useEffect(() => {
    if (props.sourceResourceid) {
      setSource(props.sourceResourceid)
    }
  }, [props.sourceResourceid])

  useEffect(() => {
    if (props.startLevel) {
      setDivLevel(props.startLevel)
    }
  }, [props.startLevel])
  
  useEffect(() => {
    if (props.sourceLevel) {
      setSourceLevel(props.sourceLevel)
    }
  }, [props.sourceLevel])
  
  useEffect(() => {
    if (props.yValueType) {
      setYValueType(props.yValueType)
    }
  }, [props.yValueType])
  useEffect(() => {
    if (props.xValueType) {
      setXValueType(props.xValueType)
    }
  }, [props.xValueType])

  useEffect(() => {
    if (props.autoQuery) {
      getData()
    }
  }, [yValueType, xValueType, start, divLevel, source, sourceLevel])

  useEffect(() => {
    if (yValueType === "WorkGroup") {
      setDivLevel(1)
    }
  }, [yValueType])



  useEffect(() => {
    if (xValueType === "WorkGroup") {
      setSourceLevel(1)
    }
  }, [xValueType])

  useEffect(() => {
    setNodes(getNodes(dataResult))
    setLinks(getLinks(dataResult))
  }, [countHash, dataResult])


  useEffect(() => {
    divLevelInput !== "" && setDivLevel(parseInt(divLevelInput))
  },[divLevelInput])

  useEffect(() => {
    sourceLevelInput !== "" && setSourceLevel(parseInt(sourceLevelInput))
  },[sourceLevelInput])


  const handleEtClick = (id: string) => {
    setYValueType("ExpressionType")
    setStart(id)
  }
  const handleYClick = (id: string, currentDivLevel: number) => {
    setYValueType("TopLevelExpression")
    setStart(id)
    // setDivLevel(currentDivLevel + 2)
    setDivLevel(2)
  }
  const handleXClick = (id: string, currentSourceLevel: number) => {
    setXValueType("TopLevelExpression")
    setSource(id)
    setSourceLevel(currentSourceLevel + 2)
    // setSourceLevel(2)
    
    
  }
  const handleYParentSelect = (parentId: string, currentDivLevel: number) => {
    if (currentDivLevel !== 1) {
      setYValueType("TopLevelExpression")
      setStart(parentId)
      setDivLevel(currentDivLevel)
    }
  }
  const handleXParentSelect = (parentId: string, currentSourceLevel: number) => {
    if (currentSourceLevel !== 1) {
      setSource(parentId)
      setSourceLevel(currentSourceLevel)
    }
  }
  // one click should show citations
  const handleCellClick = (id: string, currentDivLevel: number, sourceId: string, currentSourceLevel: number) => {
    // conditional prevent attempt to go to a level deeper than paragraph block
    // TODO: detecting block status with .include("Paragraph") is not ideal
    // data object should include a structureType property so that type can be determined
    if (!yValues[id].longTitle?.includes("Paragraph")){
      setYValueType("TopLevelExpression")
      setStart(id)
      // setDivLevel(currentDivLevel + 2)
      setDivLevel(2)
    }
    if (!xValues[sourceId].longTitle?.includes("Paragraph")){
      setXValueType("TopLevelExpression")
      setSource(sourceId)
      setSourceLevel(currentSourceLevel + 2)
    }
  }

  

  const getExpressionTypes = (resourceid: string) => {
    const query = [
      "SELECT ?expressionType",
      "WHERE {",
      "<" + resourceid + "> <http://scta.info/property/expressionType> ?expressionType . ",
      "}"
    ].join(" ")

    Axios.get("https://sparql.scta.info/ds/query", { params: { query: query } }).then((d) => {
      const expressionTypes = d.data.results.bindings.map((b) => {
        return b.expressionType.value
      })
      setTargetExpressionTypes(expressionTypes)
    })
  }

  const getData = () => {
    setDataResult([])
    setIsFetching(true)
    setShowCitations(false)

    const AllTopLevelsQuery = getCitationCounts(start, divLevel, source, sourceLevel, yValueType, xValueType, expressionTypeRollup)

    Axios.get("https://sparql-docker.scta.info/ds/query", { params: { query: AllTopLevelsQuery } }).then((d) => {
      const dataResults: any[] = d.data.results.bindings
      setIsFetching(false)
      setDataResult(dataResults)

      // prep and set xValues and xValueIds
      const xValues: CitationTableWrapperTypes.XValuesHash = getXValues(dataResults)
      setXValues(xValues)
      const xValueIds: string[] = getXValueIds(dataResults)
      //const sortedXValueIds = sortIds(xValueIds, xValues, "xFrequency", "x")
      setXValueIds(xValueIds)

      // prep and set yValues and yValueIds
      const yValues: CitationTableWrapperTypes.YValuesHash = getYValues(dataResults)
      setYValues(yValues)
      const yValueIds: string[] = getYValueIds(dataResults)
      //const sortedYValueIds = sortIds(yValueIds, yValues, "yFrequency", "y")
      setYValueIds(yValueIds)

      // prep and set counter 
      setCountHash(getCountHash(xValueIds, yValueIds, dataResults))
      setCountMatrix(getCountMatrix(xValueIds, yValueIds, dataResults))

    })
  }


  const getCountHash = (xValueIds: string[], yValueIds: string[], dataResults: any[]) => {
    const yhash: {[key: string]: {[key: string]: number}} = {}
    yValueIds.forEach((y) => {
      const xhash: {[key: string]: number} = {} // TODO: is this value a number or a string?
      xValueIds.forEach((x) => {
        dataResults.forEach((i) => {
          if (i.sourcedivlevel.value === x && i.divlevel.value === y)
            xhash[x] = parseInt(i.count.value) // TODO: is this value a number or a string?
        })
      })
      yhash[y] = xhash

    })
    return yhash

  }

  const getCountMatrix = (xValueIds: string[], yValueIds: string[], dataResults: any[]) => {
    const yhash: {[key: string]: {[key: string]: number}} = {}
    yValueIds.map((y) => {
      const xhash: {[key: string]: number} = {}
      xValueIds.forEach((x) => {
        xhash[x] = 0
        dataResults.forEach((i) => {
          if (i.sourcedivlevel.value === x && i.divlevel.value === y)
            xhash[x] = parseInt(i.count.value)
        })
      })
      yhash[y] = xhash

    })

    const matrix = Object.values(yhash).map((row) => Object.values(row))
    return matrix

  }
  const getLinks = (dataResults: any[]) => {
    const links: CitationTableWrapperTypes.Link[] = []
    dataResults.forEach((i) => {
      links.push({ source: i.sourcedivlevel?.value.split("/resource/")[1], target: i.divlevel?.value.split("/resource/")[1], count: parseInt(countHash[i.divlevel.value][i.sourcedivlevel.value]) })
    });
    return links
  }
  const getNodes = (dataResults: any[]) => {
    let nodes: CitationTableWrapperTypes.Node[] = []

    dataResults.forEach((i) => {
      nodes.push({ id: i.sourcedivlevel?.value.split("/resource/")[1], label: i.sourcedivlongtitle?.value || i.sourcedivlevel?.value.split("/resource/")[1], color: "blue", count: getYTotals(i.divlevel.value), author: i.sourceAuthorTitle?.value })
      nodes.push({ id: i.divlevel?.value.split("/resource/")[1], label: i.divlongtitle?.value || i.divlevel?.value.split("/resource/")[1], color: "red", count: getXTotals(i.sourcedivlevel.value), author: i.authorTitle?.value })
      nodes = nodes.filter((node, index, self) =>
        index === self.findIndex((t) => (
          t.id === node.id && t.label === node.label
        ))
      );
    }
    );
    return nodes
  }
  const getXValues = (dataResults: any[]) => {
    const xValuesHash: CitationTableWrapperTypes.XValuesHash = {}
    dataResults.forEach((i) => {

      // if the sourcediv is below the item level 
      // the conditional here to construct order using itemOrder + sourcedivlevelorder 
      let sourceOrder = 0;
      if (i.sourcedivlevelorder?.value && i.sourceItemNumber?.value) {
        sourceOrder = parseInt(i.sourceItemNumber.value + i.sourcedivlevelorder.value)
      }
      else if (i.sourcedivlevelorder?.value) {
        sourceOrder = parseInt(i.sourcedivlevelorder.value)
      }

      xValuesHash[i.sourcedivlevel.value] = {
        title: i.sourcedivtitle.value,
        longTitle: i?.sourcedivlongtitle?.value || "missing long title",
        //order: i.sourcedivlevelorder ? i.sourcedivlevelorder.value : "",
        order: sourceOrder,
        sourceCurrentLevel: i.sourceCurrentLevel ? parseInt(i.sourceCurrentLevel.value) : "",
        sourceParent: i.sourceCurrentParent ? i.sourceCurrentParent.value : "",
        author: i.sourceAuthor ? i.sourceAuthor.value : "",
        authorTitle: i.sourceAuthorTitle ? i.sourceAuthorTitle.value : "",
        authorBirthDate: i.sourceAuthorBirthDate ? parseInt(i.sourceAuthorBirthDate.value) : 2000,
      }
    })
    return xValuesHash
  }
  const getXValueIds = (dataResults: any[]) => {
    const uniqueIds: any[] = [...new Set(dataResults.map((x: any) => {return x.sourcedivlevel.value}))]
    return uniqueIds
  }
  const getYValues = (dataResults: any[]) => {
    const yValuesHash: CitationTableWrapperTypes.YValuesHash = {}
    dataResults.forEach((i) => {

      // if the (start)div is below the item level 
      // the conditional here to construct an order number using itemOrder + (start)divlevelorder 
      let startOrder = 0;
      if (i.divlevelorder?.value && i.startDivItemNumber?.value) {
        startOrder = parseInt(i.startDivItemNumber.value + i.divlevelorder.value)
      }
      else if (i.divlevelorder?.value) {
        startOrder = parseInt(i.divlevelorder.value)
      }

      yValuesHash[i.divlevel.value] = {
        title: i.divtitle.value,
        longTitle: i?.divlongtitle?.value || "missing long title",
        //order: i.divlevelorder ? i.divlevelorder.value : "",
        order: startOrder,
        startCurrentLevel: i.startCurrentLevel ? parseInt(i.startCurrentLevel.value) : "",
        startParent: i.startCurrentParent ? i.startCurrentParent.value : "",
        author: i.author ? i.author.value : "",
        authorTitle: i.authorTitle ? i.authorTitle.value : "",
        authorBirthDate: i.authorBirthDate ? parseInt(i.authorBirthDate.value) : 2000,
      }
    })
    console.log("yValuesHash", yValuesHash)
    return yValuesHash
  }
  const getYValueIds = (dataResults: any[]) => {
    const uniqueIds = [...new Set(dataResults.map(y => y.divlevel.value))]
    return uniqueIds
  }
  const getXTotals = (xValue: string) => {
    
    let total = 0;
    Object.keys(countHash).forEach((y) => {
      if (countHash[y][xValue]) {
        total += countHash[y][xValue]
      }

    })
    return total

  }
  const getYTotals = (yValue: string) => {
    let total = 0;
    Object.keys(countHash[yValue]).forEach((x) => {
      total += countHash[yValue][x]
    })
    return total
  }

  return (
    <div className="App">
      {props.showQueryMenu && <div className="queryMenu">
        <button onClick={getData}>Run query</button>
        <input onChange={((e) => setStart(e.target.value))} value={start} />
        {(yValueType === "TopLevelExpression" || yValueType === "WorkGroup") && <input onChange={((e) => setDivLevelInput(e.target.value))} value={!Number.isNaN(divLevel) ? divLevel.toString() : ""} />}
        {(yValueType === "ExpressionType") && <span>
          <input 
            type="checkbox"
            checked={expressionTypeRollup}
            onChange={(e) => setExpressionTypeRollup(e.target.checked)}
          />Rollup ET | 
          </span>}
        yValueType
        <select onChange={((e) => setYValueType(e.target.value))} value={yValueType}>
          <option value="TopLevelExpression">TopLevelExpression</option>
          <option value="ExpressionType">ExpressionType</option>
          <option value="WorkGroup">WorkGroup</option>
          <option value="structureType">structureType</option>
        </select>
        |
        <input onChange={((e) => setSource(e.target.value))} value={source} />
        {(xValueType === "TopLevelExpression" || xValueType === "WorkGroup") && <input onChange={((e) => setSourceLevelInput(e.target.value))} value={!Number.isNaN(sourceLevel) ? sourceLevel.toString() : ""} />}
        xValueType
        <select onChange={((e) => setXValueType(e.target.value))} value={xValueType}>
          <option value="TopLevelExpression">TopLevelExpression</option>
          <option value="ExpressionType">ExpressionType</option>
          <option value="WorkGroup">WorkGroup</option>
          <option value="structureType">structureType</option>
        </select>
      </div>}
      {/* <span onClick={() => setYFrequencySortXValue("")}>Clear Y Sort</span> | <span onClick={() => setXFrequencySortYValue("")}>Clear X Sort</span> */}
      <span onClick={() => setConstrainedView(!constrainedView)}> | Constrained View</span>
      {!showGraph && <span onClick={() => { setShowGraph(true); setShowPCA(false); setShowCitations(false) }}> | Graph</span>}
      {!showPCA && <span onClick={() => { setShowGraph(false); setShowPCA(true); setShowCitations(false) }}> | PCA</span>}
      {!showCitations && <span onClick={() => { setShowGraph(false); setShowPCA(false); setShowCitations(true) }}> | Citations</span>}
      {<span onClick={() => { setShowGraph(false); setShowPCA(false); setShowCitations(false) }}> | Clear Bttm Window</span>}
      <div>
        {targetExpressionTypes.map((et) => {
          return <span onClick={() => handleEtClick(et)}>{et} </span>
        })}
      </div>
      <div className="tableWrapper" style={{ height: "100%" }}>
        {isFetching ? <Spinner /> :
        <CitationTable xValues={xValues}
          xValueIds={xValueIds}
          yValues={yValues}
          yValueIds={yValueIds}
          countHash={countHash}
          handleCellClick={handleCellClick}
          handleXClick={handleXClick}
          handleYClick={handleYClick}
          handleXParentSelect={handleXParentSelect}
          handleYParentSelect={handleYParentSelect}
          yValueType={yValueType}
          xValueType={xValueType}
          getExpressionTypes={getExpressionTypes}
          tableStyle={constrainedView ? { "tableLayout": "fixed" } : {}}


        >
        </CitationTable>}
      </div>
      {(showGraph || showPCA || showCitations) &&
      <div style={{ width: "100%", height: "60%", position: "fixed", top: "40%", backgroundColor: "white"}}>
        {showGraph && <div>
          <CosmographProvider nodes={nodes} links={links}>
            <CosmographSearch
              //ref={search}
              className="searchStyle"
              // onSelectResult={onSearchSelectResult}
              maxVisibleItems={20}
              placeholder="Search for a node..."
              accessors={[
                { label: 'id', accessor: (node) => node.id },
                { label: 'title', accessor: (node) => node.label },
                { label: 'author', accessor: (node) => node.author }
              ]}
              onSelect={(node) => console.log(`Selected node: ${node.id}`)}
            />
            <Cosmograph
              //nodeSize={(d: number) => .5 * sigmoid(d.count)}
              // nodeSize={(d) => 5 * (sigmoid(d.count))}
              // nodeSize={(d) => d.degree}
              nodeSize={(d) => { 
                try{
                  const total = getXTotals("http://scta.info/resource/" + d.id) 
                  if (total === 0){
                    throw new Error("got zero");
                  }
                  else{
                    return 10 * (sigmoid(total))
                  }
                }catch{
                  try{
                  const total = getYTotals("http://scta.info/resource/" + d.id)
                  return 10 * (sigmoid(total))
                  }
                  catch{
                    return 0
                  }
                }
                }}
              nodeColor={(d) => d.color ?? null}
              nodeLabelAccessor={(d) => d.author + ", " + d.label}
              nodeLabelColor={"white"}
              hoveredNodeLabelColor={"white"}
              linkColor={(d) => d.color ?? null}
              linkWidth={(d) => 3 * (sigmoid(d.count))}
              //linkWidth={(d) => d.count}
              fitViewOnInit={true}
              initialZoomLevel={1}
              backgroundColor={"#f0f0f0"}
              curvedLinks
              scaleNodesOnZoom={false}
              simulationLinkDistance={100}
              simulationRepulsion={50}
              simulationGravity={0.1}
              renderHoveredNodeRing={true}
              showDynamicLabels={false}


            />
            <div className="histogramWrapper">
              <CosmographHistogram
                className="histogramStyle"
                //ref={histogram}
                barCount={100}
              />
            </div>
          </CosmographProvider>
        </div>
        }
        {showPCA &&
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'white',
            height: '500px',
          }}>
            {Object.keys(countHash).length > 0 && <PCAChart data={countMatrix} lookupHash={countHash} yValuesDateHash={Object.fromEntries(yValueIds.map(y => [y, yValues[y].authorBirthDate]))} />}
          </div>
        }
        {showCitations &&
          <div style={{
            // display: 'flex',
            // justifyContent: 'center',
            // alignItems: 'center',
            backgroundColor: 'white',
            height: "500px",
            // position: "fixed",
            // top: "40%",
            overflow: "scroll"

          }}>
            <CitationTableList start={start} source={source} />
          </div>
        }


      </div>
      }

    </div>
  );
}


